import PortalCheckbox from './PortalCheckbox.js';

export default PortalCheckbox;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalCheckbox/index.js